module.exports = __webpack_public_path__ + "assets/img/loss.32603a8c.png";